type FrameCallback = () => void

const callbacks = new Set<FrameCallback>()

let frame = 0
let bound = false

const flush = () => {
    frame = 0
    callbacks.forEach(callback => callback())
}

export const requestFrame = () => {
    if (!frame) frame = window.requestAnimationFrame(flush)
}

const bind = () => {
    if (bound) return

    bound = true
    window.addEventListener('scroll', requestFrame, { passive: true })
    window.addEventListener('resize', requestFrame)
}

const unbind = () => {
    if (!bound) return

    bound = false
    window.removeEventListener('scroll', requestFrame)
    window.removeEventListener('resize', requestFrame)

    if (frame) {
        window.cancelAnimationFrame(frame)
        frame = 0
    }
}

export const subscribeFrame = (callback: FrameCallback): (() => void) => {
    callbacks.add(callback)
    bind()
    requestFrame()

    return () => {
        callbacks.delete(callback)

        if (!callbacks.size) unbind()
    }
}

export const clamp = (value: number, min = 0, max = 1): number => Math.min(max, Math.max(min, value))

export const lerp = (from: number, to: number, amount: number): number => from + (to - from) * amount
